import React from 'react';

import '../../assets/sass/main.scss';

const Footer = () => (
  <footer id="footer" className="wrapper style1-alt">
    <div className="inner">
      <ul className="menu">
        <li><a className="fa-code" href="https://richardzilahi.hu">richardzilahi</a>
          <ul className="icons">
            <li>
              <a href="https://twitter.com/zilahy" className="fa-twitter">
                <span className="label">Twitter</span>
              </a>
            </li>
            <li>
              <a href="https://github.com/zilahir" className="fa-github">
                <span className="label">GitHub</span>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/richardzilahi/" className="fa-instagram">
                <span className="label">Instagram</span>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/richardzilahi/" className="fa-linkedin">
                <span className="label">LinkedIn</span>
              </a>
            </li>
          </ul>
        </li>
        <li>
          2020, Helsinki, Finland
        </li>
      </ul>
    </div>
  </footer>
);

export default Footer;
